export default __webpack_public_path__ + "images/walletconnect_a4166a.svg";